import { render, staticRenderFns } from "./NotificationEdit.vue?vue&type=template&id=059d1728"
import script from "./NotificationEdit.vue?vue&type=script&lang=ts"
export * from "./NotificationEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports